const spans = document.querySelectorAll("span.visually-hidden");
for (const span of spans) {
  if (span.textContent.trim() === "WeChat") {
    const parentAnchor = span.closest("a");
    if (parentAnchor) {
      parentAnchor.remove();
    }
    break; // Stop after removing the first matching element
  }
}
